var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3622_116383",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3622_116383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29836 18.625C6.04529 18.625 5.83139 18.5375 5.65666 18.3626C5.48191 18.1877 5.39453 17.9736 5.39453 17.7203C5.39453 17.467 5.48191 17.2532 5.65666 17.0788C5.83139 16.9045 6.04529 16.8173 6.29836 16.8173H9.21183L12.4522 7.18265H9.53876C9.28569 7.18265 9.07179 7.0952 8.89706 6.9203C8.72231 6.7454 8.63493 6.5313 8.63493 6.278C8.63493 6.02472 8.72231 5.81089 8.89706 5.63652C9.07179 5.46217 9.28569 5.375 9.53876 5.375H16.8849C17.138 5.375 17.3519 5.46245 17.5266 5.63735C17.7014 5.81225 17.7887 6.02634 17.7887 6.27962C17.7887 6.53292 17.7014 6.74676 17.5266 6.92113C17.3519 7.09548 17.138 7.18265 16.8849 7.18265H14.2791L11.0387 16.8173H13.6445C13.8976 16.8173 14.1115 16.9048 14.2862 17.0797C14.461 17.2546 14.5483 17.4687 14.5483 17.722C14.5483 17.9752 14.461 18.1891 14.2862 18.3634C14.1115 18.5378 13.8976 18.625 13.6445 18.625H6.29836Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.78658c1e225fb9adb76c9f0a0edf8949.svg";
export { ForwardRef as ReactComponent };